// Shared look for the course player. CPD UK guidance asks for a clear font
// such as Arial, strong contrast and no motion for people who ask for none,
// so the player sets these itself rather than inheriting the app theme.

export const FONT = 'Arial, Helvetica, sans-serif'

// Every text colour here passes WCAG AA (4.5:1) on white and on its own
// soft background.
export const colours = {
  text: '#242F40',
  muted: '#475569',
  accent: '#1F3D7C',
  accentSoft: '#EEF2FA',
  border: '#64748B',
  hairline: '#CBD5E1',
  good: '#065F46',
  goodSoft: '#ECFDF5',
  bad: '#991B1B',
  badSoft: '#FEF2F2',
  warn: '#9A3412',
  warnSoft: '#FFF7ED',
}

export const REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)'

export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  p: 0,
  m: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
}

export const bodyText = {
  fontSize: '1.0625rem',
  lineHeight: 1.7,
  textAlign: 'left',
  color: colours.text,
  maxWidth: '70ch',
}

// Applied to the player root (and to the outline drawer, which renders in a
// portal outside it).
export const playerRootSx = {
  color: colours.text,
  textAlign: 'left',
  // The app theme pins Poppins on each typography variant, so the family has
  // to be forced rather than inherited.
  '&, & *': { fontFamily: `${FONT} !important`, fontStyle: 'normal !important' },
  '& .MuiButton-root': { minHeight: 44, textTransform: 'none', fontSize: '1rem', fontWeight: 700 },
  '& .MuiIconButton-root': { minWidth: 44, minHeight: 44 },
  '& :focus-visible': { outline: `3px solid ${colours.accent}`, outlineOffset: '2px' },
  [REDUCED_MOTION]: {
    '& *, & *::before, & *::after': {
      transition: 'none !important',
      animation: 'none !important',
      scrollBehavior: 'auto !important',
    },
  },
}
